import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Rank from "../pages/rank/page";
import Channel from "../pages/channel/page";
import TopicDetail from "../pages/topic/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/rank",
    element: <Rank />,
  },
  {
    path: "/channels/:slug",
    element: <Channel />,
  },
  {
    path: "/topics/:slug",
    element: <TopicDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;